import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { Typography } from '@mui/material';
import { COLOR_PRIMARY_2, KPI_CARD_COLOR } from 'src/colors';
import { getTokenThunk } from 'src/store/Auth/actions';

const SubscriptionPlanChip = ({
  dashboardState,
  setSubscriptionModalOpen,
  address,
  centerCoord,
  setLoginModalOpen,
}) => {
  const user = useSelector(state => (state as any).dashboard.user);
  const [showCredits, setShowCredits] = useState(false);
  const isLoggedIn = getTokenThunk()();

  let userName = user && user.userName;
  if (!userName) {
    userName = 'Trial';
  }

  const handleSubscriptionModalOpen = () => {
    setSubscriptionModalOpen(true);
  };

  useEffect(() => {
    if (user.credits > 0 || user.estimatorCredits > 0  || user.subscriptionPlan !== 'starter') {
      setShowCredits(true);
    }
  }, [user]);

  const getheadertext = () => {
    if (dashboardState.showEstimatorDashboard) {
      if (user.estimatorCredits > 0 && user.subscriptionPlan == 'starter') {
        return `Estimator Credits: ${user.estimatorCredits}`;
      } else {
        return `${user.subscriptionPlan} Plan`;
      }
    } else {
      return `${user.subscriptionPlan} Plan`;
    }
  };

  return (
    <>
      {!showCredits ? (
        <Typography
          variant="body1"
          sx={{
            marginRight: '10px',
            fontWeight: 'bold',
            cursor: 'pointer',
            color: '#000',
            '&:hover': {
              color: KPI_CARD_COLOR,
            },
          }}
          onClick={() => {
            if (!isLoggedIn) {
              localStorage.setItem('estimatorCoords', JSON.stringify(centerCoord));
              localStorage.setItem('estimatorAddress', address);
              setLoginModalOpen(true);
            } else {
              handleSubscriptionModalOpen();
              localStorage.setItem('userOpenSubscriptionModalIntentionally', 'true');
            }
          }}
        >
          {isLoggedIn ? 'Subscribe' : 'Start for Free'}
        </Typography>
      ) : (
        <Typography
          variant="body1"
          onClick={handleSubscriptionModalOpen}
          style={{
            display: 'flex',
            alignItems: 'center',
            color: COLOR_PRIMARY_2,
            fontWeight: 'bold',
            textTransform: 'capitalize',
            textDecoration: 'underline',
            cursor: 'pointer',
            marginLeft: '2px',
            marginRight: '6px',
          }}
        >
          {getheadertext()}
        </Typography>
      )}
    </>
  );
};

export default SubscriptionPlanChip;
